<template>
  <a :href="computedLink" target="_blank" class="text-white">
    <div class="p-4 d-block bg-danger">
      Esta permissão não foi ativada corretamente.<br />CLIQUE AQUI para saber como ativar
    </div>
  </a>
</template>

<script>
export default {
  props: {
    hash: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      appLinkSuporte: process.env.VUE_APP_LINK_SUPORTE_VIDEOS
    };
  },
  computed: {
    computedLink() {
      return this.hash ? `${this.appLinkSuporte}${this.hash}` : this.appLinkSuporte;
    }
  }
};
</script>
